import { useRequest } from '@/hooks';
import { getIdFromField } from '@/utils';
import { useConfigStore, useFormProps } from '../stores/ConfigStore';
import useFeedback from '../hooks/useFeedback';
import useBlock from '../hooks/useBlock';

export default function usePostNotifyUser() {
	const { customDomain, formKey } = useFormProps();
	const { properties } = useConfigStore();
	const feedback = useFeedback({ addExtraData: true, excludeScreenShotDom: true });

	const [emailBlockId] = getIdFromField(properties.notification_email || '');
	const { block, state } = useBlock({ id: emailBlockId });

	const sendEmailTo =
		block.typeName === 'contact'
			? state[block?.properties?.elements?.email?.data_field]?.value
			: state.value;

	const request = useRequest({
		url: `https://${customDomain}/survey/public/notify-user`,
		data: {
			surveyKey: formKey,
			email: sendEmailTo,
			...(properties.notify?.send && {
				feedback: feedback
			})
		},
		allow: Boolean(sendEmailTo)
	});

	return request;
}
